const BaseWorker = window.Worker;

const sameOrigin = new URL(import.meta.url).origin === location.origin;
if (!sameOrigin) {
  class RemoteWorker extends BaseWorker {
    constructor(scriptURL, options) {
      const url = String(scriptURL);
      super(
        url.includes('://') && !url.startsWith(location.origin)
          ? // Launch the worker with an inline script that will use `importScripts`
            // to bootstrap the actual script to work around the same origin policy.
            URL.createObjectURL(
              new Blob(
                [
                  `importScripts=((i)=>(...a)=>i(...a.map((u)=>''+new URL(u,"${url}"))))(importScripts);importScripts("${url}")`,
                ],
                { type: 'application/javascript' }
              )
            )
          : scriptURL,
        options
      );
    }
  }

  window.Worker = RemoteWorker;
}
